import React, { useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  Form,
  Input,
  Select,
  Modal,
  Typography,
  Button,
  DatePicker,
  notification,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import WasteApi from "../../Apis/WasteApi";
import RuntimeConfigsApi from "../../Apis/RuntimeConfigsApi";
import ProductionApi from "../../Apis/ProductionApi";
import StockApi from "../../Apis/StockApi";
import ProductApi from "../../Apis/ProductApi";


const { Title } = Typography;

function AddWasteProduct({ 
  visible, 
  onClose, 
  ProductDetails, 
  ProductId,
  onWasteSuccess 
}) {

  const [formAdd] = Form.useForm();
  const [productInfo, setProductInfo] = React.useState(null);
  const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [RuntimeConfigs, setRuntimeConfigs] = React.useState([]);
  const CURRENCY = decodedToken.currency === "USD" ? "$" : "€";
  console.log("ProductDetails");
  console.log(ProductDetails);

  if (ProductDetails) {
    formAdd.setFieldsValue({
      productId: ProductDetails?.productDTOs[0]?.id,
      cookName: decodedToken?.name,
      WasteDate: dayjs(),
      invoiceNo: ProductDetails?.invoiceNumber,
      batchCode: ProductDetails?.batchCode,
      productCost: ProductDetails?.productDTOs[0]?.unitOfMeasurement2,
      quantity: ProductDetails?.unitOfMeasurement1,
      unit: ProductDetails?.unit,
    });
  }
  const getProductInfo = useCallback(() => {
    ProductApi.SingleProducts(ProductId).then((response) => {
      setProductInfo(response.payload);
      console.log()
    })
      .catch((err) => {
        console.log(err);
      });
  }, [ProductId]);

  useEffect(() => {
    if (ProductId) {
      getProductInfo();
    }
  }, [ProductId, getProductInfo]);

  const handleSubmit = (data) => {

    console.log(ProductDetails?.productDTOs[0]?.unitUomOne);
    console.log(data?.unit);
    let uomNumberOfWaste = 0;

    if(ProductDetails?.productDTOs[0]?.unitUomOne === data?.unit){
      uomNumberOfWaste = 1;
    }

    else if(ProductDetails?.productDTOs[0]?.unitUomTwo === data?.unit){
      uomNumberOfWaste = 2;
      
    } else if(ProductDetails?.productDTOs[0]?.unitUomThree === data?.unit){
      uomNumberOfWaste = 3;
    }
  

    const WasteDate = dayjs(data.WasteDate).format("DD/MM/YYYY");

    let formData = JSON.stringify({
      productName: data.productId,
      batchCode: data.batchCode,
      unit: data.unit,
      quantity: data.quantity,
      userId: decodedToken?.userId,
      cookName: data.cookName,
      createdDate: convertToUnixTimestamp(WasteDate),
      productionCoast: data.productCost,
      currency: CURRENCY,
      reason: data.reason,
      stockId: ProductDetails?.id,
      uomNumberOfWaste: uomNumberOfWaste,
      afterCookDTO: {},
      productDTO: {
        id: ProductId,
        productCode: ProductDetails?.productDTOs[0]?.productCode,
        productName: data.productId,
      },
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
      institutionDTO: {
        id: productInfo?.institutionDTO?.id,
      }
    });

    StockApi.WasteStock(formData)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Created</span>,
          description: "Added to waste Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        
        // Reset form and close modal
        formAdd.resetFields();
        onClose();
        
        // Call the success callback to refresh data without page reload
        if (onWasteSuccess) {
          onWasteSuccess();
        }
        
        console.log(response);
      })
      .catch((err) => {
        console.log(err);
        // Error Notification
        if (err.apiError?.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        } else {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err?.message || "An error occurred. Please try again.",
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  function convertToUnixTimestamp(dateString) {
    const parts = dateString.split("/");
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);

    const unixTimestamp = Date.UTC(year, month, day);
    return unixTimestamp;
  }

  const currentDate = moment().format("DD/MM/YYYY");

  const handleCancel = () => {
    formAdd.resetFields();
    onClose();
  };

  return (
    <>
      <Modal
        footer={[]}
        width={600}
        visible={visible}
        maskClosable={false}
        onCancel={handleCancel}
        onOk={onClose}
      >
        <Title level={4} className="text-center Primary-Font mb-4 pb-3">
          Waste
        </Title>
        <Form
          form={formAdd}
          name="nest-messages"
          layout="horizontal"
          labelCol={{
            span: 9,
          }}
          wrapperCol={{
            span: 15,
          }}
          className="FormClass IndividualProduct-Model"
          onFinish={handleSubmit}
        >
          <>
            <div className="Product-createDate">
              <div
                className="mb-3"
                style={{
                  display: "flex",
                  fontSize: "18px",
                  alignItems: "center",
                }}
              >
                <b className="mx-2">{currentDate}</b>

                {/* Calendar Image  */}
                <img
                  src="/assest/Images/cal.png"
                  style={{ width: "32px" }}
                  className="logo-png"
                />

              </div>
              <Form.Item
                name="createDate"
                initialValue={dayjs(currentDate, "DD/MM/YYYY")}
                className="text-lable col-lg-6 col-sm-12 col-md-7 d-none"
                rules={[
                  {
                    required: true,
                    message: "Please enter Date.",
                  },
                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  className="form-control control-input"
                />
              </Form.Item>
            </div>
            <Form.Item
              name="productId"
              label="Product Name :"
              className="text-lable disabled"
              rules={[
                {
                  required: true,
                  message: "Please Select Product Description.",
                },
              ]}
            >
              <Input disabled type="text" className="control-input" />
            </Form.Item>

            <Form.Item
              name="invoiceNo"
              label="Invoice Number :"
              className="text-lable disabled"
              rules={[
                {
                  required: true,
                  message: "Invoice Number",
                },
              ]}
            >
              <Input disabled type="text" className="control-input" />
            </Form.Item>

            <Form.Item
              name="batchCode"
              label="Batch Code :"
              className="text-lable disabled"
              rules={[
                {
                  required: true,
                  message: "Please Enter Batch Code here",
                },
              ]}
            >
              <Input disabled type="text" className="control-input" />
            </Form.Item>

            <Form.Item
              name="WasteDate"
              label="Waste date"
              className="text-lable disabled"
              rules={[
                {
                  required: true,
                  message: "Please Select Created date.",
                },
              ]}
            >
              <DatePicker
                format={"DD/MM/YYYY"}
                disabled
                className="form-control control-input disabled"
              />
            </Form.Item>
            <div className="row product-row d-flex pt-1">
              <div className=" col-2"></div>
              <div className=" col-6">
                <Form.Item
                  name="quantity"
                  label="Quantity"
                  className="text-lable disabled"

                  rules={[
                    {
                      required: true,
                      message: "Please enter Quantity.",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    placeholder="Quantity"
                    className="control-input "
                  // disabled
                  />
                </Form.Item>
              </div>
              <div className="col-4">
                <Form.Item
                  name="unit"
                  label=""
                  className="text-lable producectCol disabled"
                  // disabled
                  rules={[
                    {
                      required: true,
                      message: "Please enter Unit",
                    },
                  ]}
                >
                  <Select className="control-Select mb-3" placeholder="Select Unit">
                    {ProductDetails?.productDTOs?.[0]?.unitUomOne && (
                      <option value={ProductDetails.productDTOs[0].unitUomOne}>
                        {ProductDetails.productDTOs[0].unitUomOne}
                      </option>
                    )}

                    {ProductDetails?.productDTOs?.[0]?.unitUomTwo && (
                      <option value={ProductDetails.productDTOs[0].unitUomTwo}>
                        {ProductDetails.productDTOs[0].unitUomTwo}
                      </option>
                    )}

                    {ProductDetails?.productDTOs?.[0]?.unitUomThree && (
                      <option value={ProductDetails.productDTOs[0].unitUomThree}>
                        {ProductDetails.productDTOs[0].unitUomThree}
                      </option>
                    )}
                  </Select>
                </Form.Item>
              </div>
              <div></div>
            </div>
            <Form.Item
              name="cookName"
              label="Cook Name"
              className="text-lable"
              hidden
              rules={[
                {
                  required: true,
                  message: "Please enter Cook Name.",
                },
              ]}
            >
              <Input
                type="text"
                placeholder="Cook Name"
                className="control-input "
              />
            </Form.Item>

            <Form.Item
              name="productCost"
              label="Product Cost"
              className="text-lable"
              rules={[
                {
                  required: true,
                  message: "Please enter Product Cost.",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Product Cost"
                className="control-input disabled"
                disabled
                style={{
                  border: "none",
                  marginBottom: "0px",
                }}
                addonBefore={
                  <Button
                    style={{
                      border: "none",
                      padding: 0,
                      margin: 0,
                      background: "none",
                      cursor: "pointer",
                    }}
                  >
                    {CURRENCY}
                  </Button>
                }
              />
            </Form.Item>
            <Form.Item
              name="reason"
              label="Reason"
              className="text-lable"
              rules={[
                {
                  required: true,
                  message: "Please enter Reason.",
                },
              ]}
            >
              <Input
                type="text"
                placeholder="Reason"
                className="control-input"
              />
            </Form.Item>

            <div className="d-flex justify-content-center pt-4">
              <Button
                type="primary"
                htmlType="submit"
                className="btn btn-primary btn-save mx-2"
                style={{ width: "37%" }}
              >
                Waste
              </Button>
              <Button
                type="primary"
                className="btn btn-primary btn-back mx-2 w-20"
                style={{ width: "37%" }}
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </div>
          </>
        </Form>
      </Modal>
    </>
  );
}

export default AddWasteProduct;